import { createGenericSlice, DjangoModel } from '@store/slices/generic.slice'
import { RootState } from '@store/store'
import { EntityId } from '@reduxjs/toolkit'
import { narrationExtraReducers } from '@store/reducres/narration.reducers'
import { PromethistTranscription } from '@shared/classes'

export const narrationUrl = 'narration/'

export interface NarrationModel extends DjangoModel {
  text: string
  phonetic: string
  ssml: string
  dialogue: PromethistTranscription
  region: EntityId
  aiSlot: EntityId
  audioUrl?: string
  uploaded?: string
  audioCreated?: string
  voice: EntityId
}

const {
  slice: NarrationSlice,
  thunks: NarrationThunks,
  adapter: NarrationAdapter,
  selectors,
  actions,
} = createGenericSlice<NarrationModel>(
  'narration',
  narrationUrl,
  {},
  narrationExtraReducers
)

export const NarrationAdapterExport = NarrationAdapter

export const {
  selectById: selectNarrationById,
  selectAll: selectAllNarrations,
} = NarrationAdapter.getSelectors<RootState>(
  (state: RootState) => state.narration
)

export const { fetchAll: fetchAllNarrations, delete: deleteNarration } =
  NarrationThunks
export const {
  selectLoading: selectNarrationLoading,
  selectIsIdInProgress: selectIsNarrationIdInProgress,
  selectError: selectSlotError,
  selectByIds: selectNarrationsByIds,
} = selectors

export const {
  setInProgress: setNarrationInProgress,
  setProgressFinished: setNarrationProgressFinished,
} = actions

export default NarrationSlice.reducer
